export const font = {
	l1: '2rem',
	l2: '3rem',
	l3: '4rem',
	m1: '1rem',
	m2: '1.25rem',
	m3: '1.5rem',
	s1: '0.25rem',
	s2: '0.5rem',
	s3: '.75rem',
};
